import React from 'react'

import Mark from './Mark'

// The house header bar — nodejavascript.com site standard, part 3.
//
// Full width, sticky, this site's own near-black showing through a blur, a hairline
// underneath, the shared mark at the left, the site's own name over nodejavascript.com in
// small capitals, and NOTHING on the right. George, 19 September 2026: *"the rule for
// header is that it should look like http://127.0.0.1:4330/ but without the More detail
// link"* — and that page's bar is the brand plus one link, so removing the link leaves the
// brand and nothing else. The site is one page; the brand is not the place for navigation.
//
// 🔴 THE BRAND GOES TO THIS SITE, NOT TO nodejavascript.com. George, same day: *"new rule
// for header when clicking on the top left site name and icon, it should go to self, not
// nodejavascript.com"*. Pressing the name of the site you are already on keeps you on it.
// The way home is the FOOTER's brand line (part 4), which is where the mother-site link is
// required — once.
//
// It is a separate component from SiteHeader, which is this game's in-page hero (the
// heading, the tagline and the rules). The bar is chrome; the hero is content.
const TopBar = () => {
  return (
    <header className='dvs-top'>
      <a className='dvs-brand' href='/'>
        <span className='dvs-mark' aria-hidden='true'>
          <Mark size={24} />
        </span>
        <span className='dvs-brand-text'>
          <b>card-sharks</b>
          <small>nodejavascript.com</small>
        </span>
      </a>
    </header>
  )
}

export default TopBar
